import React from 'react';
import styled from 'styled-components';
import { space, color } from 'styled-system';
import { useSelector } from 'react-redux';
import translations from 'translations';
import Text from 'theme/text';

const WrapTab = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  ${space}
`;

const TabBtn = styled.button`
  border-radius: 8px;

  ${color}
  ${space}
`;

function AreaTabs({ handleChangeTab, activeKey, dataType }) {
  const { languageCode } = useSelector((state) => state.config);
  return (
    <WrapTab>
      <TabBtn
        type="button"
        py="s"
        px="m"
        bg={activeKey === 'amounts' ? 'primary_100' : 'grey_100'}
        onClick={() => handleChangeTab('amounts')}
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight="medium"
          color={activeKey === 'amounts' ? 'primary_500' : 'grey_400'}
          textAlign="center"
        >
          {dataType === 'usage_data'
            ? translations[languageCode].usageChart
            : translations[languageCode].revenueChart}
        </Text>
      </TabBtn>

      <TabBtn
        type="button"
        py="s"
        px="m"
        bg={activeKey === 'units' ? 'primary_100' : 'grey_100'}
        onClick={() => handleChangeTab('units')}
      >
        <Text
          fontSize="h3"
          lineHeight="h3"
          fontWeight="medium"
          color={activeKey === 'units' ? 'primary_500' : 'grey_400'}
          textAlign="center"
        >
          {dataType === 'usage_data'
            ? translations[languageCode].userChart
            : translations[languageCode].quantityChart}
        </Text>
      </TabBtn>
    </WrapTab>
  );
}

export default AreaTabs;
